export enum GuestRank {} export default GuestRank;
